import React, {ComponentType} from "react"

const REFRESHED_KEY = "retry-lazy-refreshed"

const getHasRefreshed = (): boolean => {
    try {
        return JSON.parse(globalThis.sessionStorage.getItem(REFRESHED_KEY) || "false")
    } catch {
        // sessionStorage may be inaccessible (blocked storage, embedded webview).
        // Report "already refreshed" so we never enter a reload we cannot guard against.
        return true
    }
}

const setHasRefreshed = (value: boolean): boolean => {
    try {
        globalThis.sessionStorage.setItem(REFRESHED_KEY, JSON.stringify(value))
        return true
    } catch {
        return false
    }
}

export const retryImport = (componentImport) => {
    return new Promise((resolve, reject) => {
        const hasRefreshed = getHasRefreshed()
        componentImport()
            .then((component) => {
                setHasRefreshed(false)
                resolve(component)
            })
            .catch((error) => {
                // Reload only if the guard flag was persisted, otherwise we could loop forever.
                if (!hasRefreshed && setHasRefreshed(true)) {
                    return globalThis.location.reload()
                }
                reject(error)
            })
    }) as Promise<{default: ComponentType<any>}>
}

export const reactLazyRetry = (componentImport) => React.lazy(() => retryImport(componentImport))
